// @mui
import { Container, Stack, Typography } from '@mui/material';
// components
import Page from '../../components/page';
import Form from '../../sections/form/insured/form';
// config
import config from '../../config';

// ----------------------------------------------------------------------

const { header } = config;

const Insured = () => (
  <Page title={'Insured'}>
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h4" gutterBottom>
          {header}
        </Typography>
      </Stack>

      <Form />
    </Container>
  </Page>
);

export default Insured;
